import React, { Component } from "react";
import TextField from "./../component/TextField";
//Service import
import service from "../services";
//Validation import
import SimpleReactValidator from "simple-react-validator";
import ErrorPopUp from "../component/errorPopUp";
import Loader from "../component/loader";
import moment from "moment-timezone";
import TextEditor from "../component/TextEditor";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import Slider from "react-slick";

import UploadForm from "../component/fpg/create/UploadForm";
import CopyIcon from "../icons/copyicon";
import commonImage from '../commonImage';
import DropdownMaster from "../component/DropdownMaster";
import PopUpCustomAll from "../component/fpg/create/popUpCustomAll";

let sub;
let updateAt;
let hour;
let minutes;
let state;
let updatedBy;
const content = {
  entityMap: {},
  blocks: [
    {
      key: "637gr",
      text: "Initialized from content state.",
      type: "unstyled",
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {}
    }
  ]
};
export default class Screening extends Component {
  constructor() {
    super();
    this.state = {
      hashtagCode: "",
      loaderFlag: false,
      editorState: EditorState.createEmpty(),
      deleteImagePopup: false,
      deleteImageId: '',
      sponsorOffer: [
        {
          _id: Math.random(),
          title: "",
          description: EditorState.createEmpty(),
          cta: "",
          url: "",
          presented_by:" ",
          type: 'select0',
          images: [
            {
              _id: Math.random(),
              link: "",
              inSite: ""
            },
            {
              _id: Math.random(),
              link: "",
              inSite: ""
            },
            {
              _id: Math.random(),
              link: "",
              inSite: ""
            }
          ],
        },
        {
          _id: Math.random(),
          title: "",
          description: EditorState.createEmpty(),
          cta: "",
          url: "",
          presented_by:" ",
          type: 'select0',
          images: [
            {
              _id: Math.random(),
              link: "",
              inSite: ""
            },
            {
              _id: Math.random(),
              link: "",
              inSite: ""
            },
            {
              _id: Math.random(),
              link: "",
              inSite: ""
            }
          ],
        },
        {
          _id: Math.random(),
          title: "",
          description: EditorState.createEmpty(),
          cta: "",
          url: "",
          presented_by:" ",
          type: 'select0',
          images: [
            {
              _id: 1,
              link: "",
              inSite: ""
            },
            {
              _id: 2,
              link: "",
              inSite: ""
            },
            {
              _id: 3,
              link: "",
              inSite: ""
            }
          ],
        }
      ],

      ScreenImage_option: [
        { _id: 'select0', name: 'None' },
        { _id: 'select1', name: 'Image(s) + Text' },
        { _id: 'select2', name: 'Text Only' },
        { _id: 'select3', name: 'Image(s) Only' },
      ],
      deleteImage:false
    };
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      validators: {
        urlValidation: {
          // name the rule
          message: "Please use a valid :attribute",
          rule: (val, params, validator) => {
            return (
              validator.helpers.testRegex(
                val,
                /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
              ) && params.indexOf(val) === -1
            );
          },
          required: false // optional
        }
      }
    });
    this.apiserve = new service();
  }



  componentDidMount = async () => {
    this.getAllScreening();
    this.getScreeningEvent();
    this.setState({
      loaderFlag: true
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  getScreeningEvent = () => {
    sub = this.apiserve.getevent().subscribe(response => {
      switch (response.event) {
        case "admin|screenerGetEnvironment":
          this.setState({
            getScreening: response.data
          });
          if (response.data.sponsorOffer) {
            var sponsorOffer = response.data.sponsorOffer.map(item => {
              var offer = {
                _id: item._id,
                cta: item.cta,
                description: item.description,
                title: item.title,
                url: item.url,
                presented_by:item.presented_by,
                type:  item.type,
                images:item.images
              //  images: response.data && response.data.images?.map((image) => {
              //     var imageData = {
              //         _id: Math.random(),
              //         inSite: image.inSite,
              //         link: image.link
              //     }
              //     return imageData
              // })
              };
              return offer;
              
            });

            if (sponsorOffer !== undefined) {
              const docs = sponsorOffer.map(e => {
                const blocksFromHtml = htmlToDraft(e.description);
                const { contentBlocks, entityMap } = blocksFromHtml;
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                e.description = EditorState.createWithContent(contentState);
                return e;
              });
            } else this.setState({ loaderFlag: false });

            this.setState({
              hashtagCode: response.data.hashtagCode,
              sponsorOffer,
              loaderFlag: false
            });
          } else this.setState({ loaderFlag: false });
          break;
        case "admin|screenerSetEnvironment":
          if (response.data.error) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsg: response.data.error
            });
          } else {
           
            this.apiserve.success(this.state.deleteImage ? "Screening Deleted Successful." : "Screening Created Successful.");
            this.setState({ loaderFlag: false, deleteImage:false });
            this.getAllScreening();
          }
          break;
        case "admin|screenerLastUpdated":
          if (response.data.updatedAt) {
            this.setState(
              {
                getLastUpdate: response.data
              },
              () => {
                updateAt = new Date(response.data && response.data.updatedAt);
                hour = moment.tz(updateAt, "US/Mountain").format("h")
                  ? moment.tz(updateAt, "US/Mountain").format("h")
                  : "";
                minutes = moment.tz(updateAt, "US/Mountain").format("mm")
                  ? moment.tz(updateAt, "US/Mountain").format("mm")
                  : "";
                state = moment.tz(updateAt, "US/Mountain").format("A")
                  ? moment.tz(updateAt, "US/Mountain").format("A")
                  : "";
                updatedBy = response.data && response.data.updatedBy;
              },
              // this.apiserve.sendevent("admin|screenerLastUpdated", { type: 1 })
            );
          }
      }
    });
  };

  getAllScreening = () => {
       this.apiserve.sendevent("admin|screenerGetEnvironment", {});
    this.apiserve.sendevent("admin|screenerLastUpdated", { type: 1 });
  };

  submitFn = async e => {
  
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      var sponsorOffer = this.state.sponsorOffer.map(item => {
        const name =
          item && item.description ? convertToRaw(item && item.description.getCurrentContent()) : "";
        const markup = draftToHtml(name);
        var List = {
          title: item.title,
          cta: item.cta,
          url: item.url,
          description: markup,
          images:item.images,
          presented_by:item.presented_by,
          type:item.type,
          // type: item && item.type
        };
        return List;
      });
      const data = {
        // hashtagCode: this.state.hashtagCode,
        sponsorOffer
      };
      this.apiserve.sendevent("admin|screenerSetEnvironment", data);
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  handelInput = (e, id) => {
     const { name, value } = e.target;
    this.state.sponsorOffer.map(dataList => {
      if (dataList._id === id) dataList[name] = value;
    });
    this.setState({});
  };

  cancelBTN = e => {
    e.preventDefault();
    window.location.reload();
  };

  handelInputEmbed = e => {
    e.preventDefault();
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  onEditorStateChange = (description, id) => {
    this.state.sponsorOffer.forEach(dataList => {
      if (dataList._id === id) {
        dataList.description = description;
      }
    });

    this.setState({});
  };

  validateModel = () => {
    this.setState({
      errorMsg: false
    });
  };
  handleImage(e, id,id1) {
    e.stopPropagation()
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    var self = this;
    reader.onloadend = (event) => {
      this.setState({
        file: file,
      }, () => {
        const fileList = Math.round((file && file.size / 1024));
        if (fileList >= 2048) {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file smaller than 2 MB'
          })
          return false;
        }
        if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
          setTimeout(() => {
            self.imageUploadOne(file, id,id1,event.target.result);
          }, 0)
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file for PNG,JPG or JPEG'
          })
        }
      })
    }
  }
  imageUploadOne = (file, id,id1, img) => {
    
    const imagePreloaderId = `imagePreloader_${id}`
    const newState = { ...this.state }
    newState[imagePreloaderId] = true
    this.setState(newState)
    var fileSet = commonImage(file,false,'',img)
    fileSet.then((value) => {
        this.state.sponsorOffer.map((ir, i) => {
        
          if(ir._id=== id1){
            ir.images.forEach(image => {
              const imagePreloaderId = `imagePreloader_${id}`
              const newState = { ...this.state }
              newState[imagePreloaderId] = false
              this.setState(newState)
            
              if (image._id === id) {
                image.inSite = value
              }
  
            });
          }
       
        })

        this.setState({})
      });
  };
  insideOnchange = (e, id,id1) => {
   
    const { name, value } = e.target
    this.state.sponsorOffer.map((im,i)=>{
      
      im.images.forEach(inside => {
        if (inside._id === id) {
          inside.link = value
        }
      });
    })
   
    this.forceUpdate()
  }
  onChangeScreeningType = (e, id) => {
    const { name, value } = e.target;

    let dummyData = this.state.sponsorOffer
    dummyData.forEach((screen) => {
      if (screen._id === id) {
        screen[name] = value
        // ...screen
        // }
      }
    })

    this.setState({ sponsorOffer: dummyData })
  };
  deleteImage(id) {
    this.setState({
        deleteImagePopup: true,
        deleteImageId: id
    })
}
closeAdminUser = () => {
  this.setState({
      deleteImagePopup: false
  });
};
deleteImagePopup = () => {

  let newsponsorOffer = this.state.sponsorOffer.map((dr,i)=>{
    if (dr.images.length) {
      dr.images.forEach(image => {
          if (image._id === this.state.deleteImageId) {
              image.inSite = ''
          }
      });
  }
  return dr
  })

    this.setState({ loaderFlag: true,deleteImage:true });

    var sponsorOffer = newsponsorOffer?.map(item => {
      const name =
        item && item.description ? convertToRaw(item && item.description.getCurrentContent()) : "";
      const markup = draftToHtml(name);
      var List = {
        title: item.title,
        cta: item.cta,
        url: item.url,
        description: markup,
        images:item.images,
        presented_by:item.presented_by,
        type:item.type,
        // type: item && item.type
      };
      return List;
    });
    const data = {
      // hashtagCode: this.state.hashtagCode,
      sponsorOffer
    };
    this.apiserve.sendevent("admin|screenerSetEnvironment", data);
  this.setState({
      deleteImagePopup: false,
      deleteImageId: '',

  })
}

imageOnError = (event) => {
  event.currentTarget.src = `/images/image-placeholder.png`;
};

handleKeySlider = (e) => {
  if (e.keyCode === 9) { // Check if the pressed key is Tab (key code 9)
      e.preventDefault(); // Prevent the default tab focus behavior
  }
}
  render() {
    const { sponsorOffer } = this.state;
    var settings = {
      customPaging: function (i) {
        return (
          <a>{i + 1}</a>
        );
      },
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
      <div className="right_side_wrapper ">
        <ul className="fpg_admin_tab disp_flex">
          <li className="active">
            <p className="uppercase text_left">
              <div>Screening Environment</div>
            </p>
          </li>
        </ul>
        {updateAt === undefined ? (
          ""
        ) : (
          <>
            <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
              <p></p>
              <p className="update_date">
                Last Update: {hour}:{minutes} {state} -{" "}
                {moment.tz(updateAt, "US/Mountain").format("MM/DD/YYYY") === ""
                  ? moment.tz(updateAt, "US/Mountain").format("MM/DD/YYYY")
                  : ""}{" "}
                Last Updated By: {updatedBy && updatedBy.fname ? updatedBy && updatedBy.fname : ""}{" "}
                {updatedBy && updatedBy.lname ? updatedBy && updatedBy.lname : ""}
              </p>
            </div>
          </>
        )}
        <div className="fpg_tabcontent ">
          <div className="screening_page">
            {/* <div className="screening_top mb_25">
              <div className="field_row">
                <div className="field_row_inner">
                  <label className="font_500">Sundance Hashtag Embed Code</label>
                  <div className="field_input relative">
                    <textarea
                      name="hashtagCode"
                      value={this.state.hashtagCode}
                      onChange={this.handelInputEmbed}
                    ></textarea>
                    <span style={{ color: "red" }}>
                      {this.validator.message("hashtagCode", this.state.hashtagCode, "required")}
                    </span>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="">
              <div className="field_row">
                <label className="font_500">Community Engagement Offers</label>
              </div>
              <div className="screening_form mt_25">
                <form>
                  <div className="d_flex">
                    {sponsorOffer &&
                      sponsorOffer.map((item, index) => {
                        return (
                          <div className="form_side mr_15 mb_15" key={index}>
                            <div className="screening_header text_center">
                              <p>Sponsor Offer - {index + 1} </p>
                            </div>
                            <div className="sponser_form">
                            <div className="field_row">
                              <div className="field_row_inner">
                              <label class="null">Offer Type </label>
                                <DropdownMaster
                                  name={`type`}
                                  onChange={(e) => this.onChangeScreeningType(e, item._id)}
                                  value={item.type}
                                  options={this.state.ScreenImage_option}
                                  selectedDrop={true}
                                />
                              </div>
                              </div>
                              <div className="field_row">
                                <TextField
                                  type="text"
                                  name="title"
                                  label="Offer Title"
                                  value={item.title}
                                  onChange={e => this.handelInput(e, item._id)}
                                  fpgerror={this.validator.message(
                                    "title" + (index + 1),
                                    item.title,
                                    "required"
                                  )}
                                />
                              </div>
                             
                              
                              {/* {this.state.type.map((screenTxt) => {
                                return ( */}
                              <>{
                                item.type === 'select0'? " ":""
                              }
                                {item.type === 'select1'  ?
                                  <>
                                    <Slider {...settings} >
                                      {item.images &&
                                        item.images.map((item1, index) => {
                                          
                                          const imagePreloaderState = `imagePreloader_${item1._id}`
                                          return (
                                            <div>
                                              <div className="media_image mb_0 absolute_loader">
                                                {this.state[imagePreloaderState] ?
                                                  <Loader />
                                                  :
                                                  <img src={item1.inSite ? this.apiserve.imageUrl + item1.inSite : item1.link ? item1.link : '/images/image-placeholder.png'} alt="image"  onError={(e) => this.imageOnError(e)}/>
                                                }
                                                <span className="upload_message">Upload PNG/JPEG of max size of 2MB</span>
                                                <UploadForm item={item1} handleImage={(e) => this.handleImage(e, item1._id,item._id)} deleteImage={() => this.deleteImage(item1._id)} iconDelete={true} />
                                              </div>
                                              <div className="field_row">
                                                <div className="field_input relative">
                                                  <input
                                                    type="text"
                                                    placeholder="https://cloudfront.aws.com/sdf2345"
                                                    name='link'
                                                    id={item1._id}
                                                    value={item1.link}
                                                    onChange={(e) => this.insideOnchange(e,item1._id)}
                                                  />
                                                  <span className="copy_box pointer_auto">
                                                    <CopyIcon />
                                                  </span>
                                                </div>
                                              </div>
                                              {index === 0 ?
                                                <span style={{ color: 'red' }}>{this.validator.message('image or link', item1.link || item1.inSite, 'required|urlValidation')}</span>
                                                : ''
                                              }
                                            </div>
                                          )
                                        })}
                                    </Slider>
                                    <div className="field_row">
                                      <div className="field_row_inner">
                                        <label>Offer Description</label>
                                        <div className="field_input relative editor_400">
                                          <TextEditor
                                            name="description"
                                            editorState={item.description}
                                            value={item.description}
                                            onEditorStateChange={e => this.onEditorStateChange(e, item._id)}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                  : item.type === 'select2' ?
                                    <div className="field_row">
                                      <div className="field_row_inner">
                                        <label>Offer Description</label>
                                        <div className="field_input relative editor_400">
                                          <TextEditor
                                            name="description"
                                            editorState={item.description}
                                            value={item.description}
                                            onEditorStateChange={e => this.onEditorStateChange(e, item._id)}
                                          />
                                        </div>
                                      </div>
                                    </div> : item.type === 'select3' ?
                                        <Slider {...settings} >
                                        {item.images &&
                                          item.images.map((item1, index) => {
                                            const imagePreloaderState = `imagePreloader_${item1._id}`
                                            return (
                                              <div>
                                                <div className="media_image mb_0 absolute_loader">
                                                  {this.state[imagePreloaderState] ?
                                                    <Loader />
                                                    :
                                                    <img src={item1.inSite ? this.apiserve.imageUrl + item1.inSite : item1.link ? item1.link : '/images/image-placeholder.png'} alt="image" />
                                                  }
                                                  <span className="upload_message">Upload PNG/JPEG of max size of 2MB</span>
                                                  <UploadForm item={item1} handleImage={(e) => this.handleImage(e, item1._id,item._id)} deleteImage={() => this.deleteImage(item1._id)} iconDelete={true} />
                                                </div>
                                                <div className="field_row">
                                                  <div className="field_input relative">
                                                    <input
                                                      type="text"
                                                      placeholder="https://cloudfront.aws.com/sdf2345"
                                                      name='link'
                                                      id={item1._id}
                                                      value={item1.link}
                                                      onChange={(e) => this.insideOnchange(e,item1._id)}
                                                      onKeyDown={(e) => this.handleKeySlider(e)}
                                                    />
                                                    <span className="copy_box pointer_auto">
                                                      <CopyIcon />
                                                    </span>
                                                  </div>
                                                </div>
                                                {/* {index === 0 ?
                                                  <span style={{ color: 'red' }}>{this.validator.message('image or link', item.link || item.inSite, 'required|urlValidation')}</span>
                                                  : ''
                                                } */}
                                              </div>
                                            )
                                          })}
                                      </Slider>:''}


                              </>
                                 <div className="field_row">
                                <TextField
                                  type="text"
                                  name="cta"
                                  label="Offer CTA Title"
                                  value={item.cta}
                                  onChange={e => this.handelInput(e, item._id)}
                                  fpgerror={this.validator.message(
                                    "cta" + (index + 1),
                                    item.cta,
                                    "required"
                                  )}
                                />
                              </div>
                              <div className="field_row">
                                <TextField
                                  type="text"
                                  name="url"
                                  label="Offer CTA URL"
                                  value={item.url}
                                  onChange={e => this.handelInput(e, item._id)}
                                  fpgerror={this.validator.message(
                                    "url" + (index + 1),
                                    item.url,
                                    "required|urlValidation"
                                  )}
                                />
                              </div>
                              <div className="field_row">
                                <TextField
                                  type="text"
                                  name="presented_by"
                                  label="Presented By"
                                  value={item.presented_by}
                                  onChange={e => this.handelInput(e, item._id)}
                                  fpgerror={this.validator.message(
                                    "url" + (index + 1),
                                    item.presented_by,
                                    "required"
                                  )}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="text_center field_row w_100 buttons_outer mb_0">
            <button className="uppercase" type="button" onClick={this.cancelBTN}>
              CANCEL
            </button>
            <button className="uppercase active" type="button" onClick={e => this.submitFn(e)}>
              SAVE
            </button>
          </div>
        </div>
        {this.state.deleteImagePopup ? (
                    <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.deleteImagePopup}
                    />
                ) : (
                        ""
                    )}
        {this.state.errorMsg ? (
          <ErrorPopUp errorMsg={this.state.errorMsg} errorMsgPopup={this.validateModel} />
        ) : (
          ""
        )}
        {this.state.loaderFlag ? <Loader /> : ""}
      </div>
    );
  }
}